function resize(game) {
  const canvas = document.querySelector('canvas');
  if (canvas === null) {
    console.error('No game canvas found for resize!');
    return;
  }
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const ratioH = windowHeight / game.config.height;
  const ratioW = windowWidth / game.config.width;
  if (ratioH < ratioW) {
    canvas.style.height = `${game.config.height * ratioH}px`;
    canvas.style.width = `${game.config.width * ratioH}px`;
  } else {
    canvas.style.height = `${game.config.height * ratioW}px`;
    canvas.style.width = `${game.config.width * ratioW}px`;
  }
}

export default resize;
